import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Collapse} from 'bootstrap'

import {useErrorHandler} from '../../../../../_metronic/helpers/ErrorHandler'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Loading} from '../../../../../_metronic/elements/Loading'
import {useIsMobile} from '../../../../shared/responsive'
import {CreateFieldButton, Search} from '../../Toolbar/Toolbar'
import Field from './Field';
import * as GisDataAdapter from '../services/GisDataAdapter'
import '../FieldModuleOnboardingCallout.style.scss'

const ListFields = () => {
    const [ loading, setLoading ] = useState(true)
    const [ fields, setFields ] = useState([])
    const { errorHandler } = useErrorHandler()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const isMobile = useIsMobile()

    useEffect(() => {
        errorHandler(GisDataAdapter.listFields()).then(res => {
            if (res?.ok) {
                setFields(res.data);
            }

            setLoading(false);
        });
        // errorHandler identity changes every render; load fields once on mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (loading || fields.length < 1) {
            return;
        }

        const collapseElement = document.getElementById('kt_list_fields_collapsible');
        const toggle = document.querySelector('[data-bs-target="#kt_list_fields_collapsible"]');

        if (!collapseElement) {
            return;
        }

        const instance = Collapse.getOrCreateInstance(collapseElement, { toggle: false });

        if (!collapseElement.classList.contains('show')) {
            instance.show();
        }

        toggle?.classList.remove('collapsed');
        toggle?.setAttribute('aria-expanded', 'true');
    }, [fields.length, loading]);

    const showMobileOnboarding = !loading && fields.length < 1;

    if (isMobile) {
        return (
            <div className="field-view-mobile-shell displayable">
                <div className="card shadow-sm right-card-data field-view-mobile-card">
                    <div className="field-view-mobile-card__header">
                        <button
                            type="button"
                            className="btn btn-sm btn-light field-view-mobile-card__back"
                            onClick={() => navigate("/gis", { state: { keepDrawerOpen: true } })}
                        >
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr063.svg"
                                className="svg-icon svg-icon-2"
                            />
                            <span>{t("common:navigation.back_home")}</span>
                        </button>
                        <h2 className="field-view-mobile-card__title">{t("fields:list.title")}</h2>
                        <div className="field-view-mobile-card__controls">
                            <div className="field-view-mobile-card__search">
                                <Search />
                            </div>
                            <CreateFieldButton className="w-100 field-view-mobile-card__create-button" />
                        </div>
                    </div>

                    {showMobileOnboarding && (
                        <div className="gis-field-onboarding__mobile-banner">
                            <p className="gis-field-onboarding__title">{t("fields:onboarding.title")}</p>
                            <p className="gis-field-onboarding__text">{t("fields:onboarding.description")}</p>
                        </div>
                    )}

                    <div className="field-view-mobile-panel">
                        <div className={`card-body ${(loading || fields.length < 1) ? "p-5" : "p-0"}`}>
                            {loading && <Loading />}
                            {!loading && fields.map(field => {
                                return <Field field={field} />
                            })}
                            {!loading && fields.length < 1 && (
                                <>
                                    <h5>{t("fields:list.messages.no_fields")}</h5>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
        <div id="gis-field-module-card" className="card shadow-sm field-view-container displayable right-card-data">
            <div className="card-header collapsible">
                <h4
                    className="card-title cursor-pointer"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_list_fields_collapsible"
                    aria-expanded="true"
                    aria-controls="kt_list_fields_collapsible"
                >
                    {t("fields:list.title")}
                </h4>
                <div className="card-toolbar">
                    <CreateFieldButton />
                </div>
            </div>
            <div id="kt_list_fields_collapsible" className="collapse show">
                <div className={`card-body ${(loading || fields.length < 1) ? "p-5" : "p-0"}`}>
                    {loading && <Loading />}
                    {!loading && fields.map(field => {
                        return <Field field={field} />
                    })}
                    {!loading && fields.length < 1 && (
                        <>
                            <h5>{t("fields:list.messages.no_fields")}</h5>
                        </>
                    )}
                </div>
            </div>
        </div>
        </>
    )
}

const ListFieldsContainer = () => {

    return (
        <>
        <div className="d-flex flex-column flex-row-auto field-view-flex-container">
              <div className="d-flex flex-column-auto">
                  <ListFields />
              </div>
          </div>
        </>
    )
}

export default ListFieldsContainer;
